export default __webpack_public_path__ + "static/media/dev-juan-02.1e0e29f7.jpg";